<template>
  <v-navigation-drawer
    class="pl-navigation-drawer"
    fixed
    app
    dark
    permanent
    stateless
    :mini-variant="mini"
    @click.native.stop="mini ? $emit('changeSidebarState') : ''"
  >
    <toolbar :mini="mini" v-if="!imageSrc" />
    <v-list dense class="pl-dense-datepicker">
      <div class="pl-border-top-datepicker">
        <div v-if="checkPermission(calendarPermission)" @mouseup="navigateToDateInNewWindow($event)">
          <router-link to="/" v-if="imageSrc">
            <v-img :src="imageSrc" alt="" />
          </router-link>
          <v-date-picker
            v-if="!mini"
            v-model="picker"
            :landscape="landscape"
            :reactive="reactive"
            ref="datepicker"
            class="pl-datepicker pb-1"
            dark
            no-title
            color="primary"
            locale="ru"
            first-day-of-week="1"
            @input="changeDate"
          />
          <div v-else class="calendar_view_min">
            <button
              type="button"
              class="v-btn v-btn--active v-btn--icon v-btn--floating theme--dark primary v-btn-calendar-min"
            >
              <div class="v-btn__content">{{ getDateDay }}</div>
            </button>
          </div>
        </div>
      </div>

      <div v-for="item in items" :key="item.text">
        <v-layout v-if="item.heading" :key="item.heading" row align-center>
          <v-flex xs6>
            <v-subheader v-if="item.heading && checkHardRulez(item)">
              {{ item.heading }}
            </v-subheader>
          </v-flex>

          <v-flex xs6 class="text-xs-center">
            <a href="#" class="body-2 black--text">EDIT</a>
          </v-flex>
        </v-layout>

        <v-list-group
          v-else-if="item.children && item.children.length && checkHardRulez(item)"
          v-model="item.model"
          :class="[mini ? 'pl-sidebar-items__mini' : 'pl-sidebar-items']"
          :disabled="item.model && mini"
          :key="item.text"
          :prepend-icon="item['icon-prepend']"
          :append-icon="item.model ? item['main'] : item['icon-alt']"
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <router-link
            v-for="child in item.children"
            :key="child.text"
            :to="{ name: child.name, params: child.params }"
            class="pl-navigation-drawer__link"
            event=""
            @click.native.prevent.capture="routerHandler({ name: child.name, params: child.params })"
          >
            <v-list-tile class="test-active" @click="">
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title class="title-child">
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </router-link>
        </v-list-group>

        <v-list-group
          v-else-if="(!item.children || (item.children && !item.children.length)) && checkHardRulez(item)"
          :prepend-icon="item['icon-prepend']"
          :append-icon="''"
          class="pl-sidebar-items"
          @click="$router.push({ name: item.name })"
          :class="{ 'router-link-exact-active': $route.name == item.name }"
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <router-link v-else-if="checkHardRulez(item)" :to="{ name: item.name }" class="pl-navigation-drawer__link 213">
          <v-list-tile :key="item.text">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </router-link>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Toolbar from './Toolbar'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'
import store from '@/store'
import router from '@/router'
import permissions_mixin from '@/mixins/permissions_mixin'
import { autoscheduleConstants } from '@/constants'

export default {
  name: 'Sidebar',
  mixins: [permissions_mixin],
  props: {
    items: {
      type: Array,
    },
    show: {
      type: Boolean,
    },
    mini: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    toolbar: Toolbar,
  },
  data: () => ({
    picker: null,
    landscape: false,
    reactive: false,
  }),
  async created() {
    await this.$store.dispatch('FETCH_USER_COMPANY')
  },
  mounted() {
    if (!this.selectedDate) store.commit('setSelectedDate')
    this.picker = this.selectedDate.format(this.$config.format.datepickerDate)
  },
  computed: {
    calendarPermission() {
      return this.$config.permissions.PERMISSIONS_CONSTANTS.CALENDAR
    },
    ...mapGetters(['selectedDate', 'unitWindows', 'userPermissions', 'load', 'userCompanyNew']),
    ...mapGetters('autoschedule', {
      commonData: 'commonData',
    }),
    userCompany() {
      return this.$store.getters.userCompany
    },
    isSuperUser() {
      return this.$store.getters.user.is_superuser
    },
    isFocusGroup() {
      return autoscheduleConstants.workPositionsIdsForAutoschedule.some(
        id => id === this.$store.getters.user.work_position_id,
      )
    },
    getDateDay() {
      return moment(this.picker).format('D')
    },
    imageSrc() {
      if (!this.userCompanyNew?.images?.length) return
      return `${this.$config.cdnServer}/${_.last(this.userCompanyNew.images).filename}`
    },
  },
  methods: {
    ...mapMutations(['setSelectedDate']),
    checkHardRulez(item) {
      return (
        (item.permissions !== 'superUser' && item.permissions !== 'superUserPlusFocus') ||
        (item.permissions == 'superUser' && this.isSuperUser) ||
        (item.permissions == 'superUserPlusFocus' && (this.isSuperUser || this.isFocusGroup))
      )
    },
    navigateToDateInNewWindow(e) {
      try {
        if (e && e.button === 1) {
          const button = e.target.closest('.v-btn')
          if (button && e.target.closest('.v-date-picker-table')) {
            const year = this.$refs.datepicker.$refs.table.displayedYear
            const month = this.$refs.datepicker.$refs.table.displayedMonth + 1
            const date = moment(`${year}-${month}-${button.textContent}`)
            let unitId = null
            if (this.$route.query !== undefined && this.$route.query.hasOwnProperty('unit_id')) {
              unitId = this.$route.query.unit_id
            }

            let uri = null
            if (unitId !== null) {
              uri = this.$router.resolve({ name: 'index', query: { selected_date: date, unit_id: unitId } })
            } else {
              uri = this.$router.resolve({ name: 'index', query: { selected_date: date } })
            }
            if (uri) {
              window.open(uri.href, '_blank')
            }
          }
        }
      } catch (error) {
        console.info(error)
      }
    },
    routerHandler(payload) {
      if (!this.load) router.push(payload)
    },
    changeDate(date) {
      const data = {
        selected_date: date,
      }

      if (this.$route.query.unit_id) data.unit_id = this.$route.query.unit_id
      router.push({ name: 'index', query: data })
    },
  },
  watch: {
    selectedDate(value) {
      this.picker = value.format(this.$config.format.datepickerDate)
    },
  },
}
</script>
